let base = {};

const local = {
	api: {
		url: 'https://api.local.sipgate.com:3396/v2',
	},
	identity: {
		url: 'https://login.dev.sipgate.com/auth/realms/sipgate-apps/protocol/openid-connect/token',
	},
};

const development = {
	api: {
		url: 'https://api.dev.sipgate.com/v2',
	},
	identity: {
		url: 'https://login.dev.sipgate.com/auth/realms/sipgate-apps/protocol/openid-connect/token',
	},
};

const production = {
	api: {
		url: 'https://api.sipgate.com/v2',
	},
	identity: {
		url: 'https://api.sipgate.com/login/sipgate-apps/protocol/openid-connect/token',
	},
};

if (process.env.NODE_ENV === 'development') {
	base = development;
} else if (process.env.NODE_ENV === 'local') {
	base = local;
} else {
	if (window.location.hostname === 'login.dev.sipgate.com') {
		base = development;
	} else if (window.location.hostname === 'login.local.sipgate.com') {
		base = development;
	} else {
		base = production;
	}
}

// noinspection UnnecessaryLocalVariableJS
const config = base;

export default config;



// WEBPACK FOOTER //
// ./src/api/config.js